import { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

// The settings shell owns the page header; a tab that needs header actions
// (General's Unsaved / Reset / Save) portals them into this slot.
export const SettingsHeaderSlotContext = createContext(null);

export const SettingsHeaderActions = ({ children }) => {
  const slot = useContext(SettingsHeaderSlotContext);
  return slot ? createPortal(children, slot) : children;
};
